export const getAppConfigSlug = (site?: MiniSlug) => {
  if (site) {
    return `apps/configs/mini-sites/${site}`;
  }

  return 'apps/configs/immigrantinvest';
};

export default getAppConfigSlug;
